import { render, staticRenderFns } from "./multiLangEnter.vue?vue&type=template&id=270a1a46&"
import script from "./multiLangEnter.vue?vue&type=script&lang=ts&"
export * from "./multiLangEnter.vue?vue&type=script&lang=ts&"
import style0 from "./multiLangEnter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports